import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';

@Component({
  selector: 'archived-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArchivedProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'requestor',
      'currentCreatedAt',
      'company',
      'archivalReason',
      'projectPlacement.address',
      'productType',
      'displayStatus',
      'star',
    ];
  }

  protected getLocalStorageKey(): string {
    return 'ArchivedProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'status/Gearchiveerd,Niet_uitgevoerd';
  }

  // Override
  protected filterOutIPBoardProjects(): boolean {
    return true;
  }

  public getPageTitle(): string {
    return 'Archief';
  }

  // Override
  public getDefaultSort(): string {
    return 'currentCreatedAt';
  }
}
